import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M7.838 1.453a.6.6 0 0 1 .516.01l5.415 2.714a.6.6 0 0 1 .331.537v6.995a.6.6 0 0 1-.366.552l-5.415 2.292a.6.6 0 0 1-.486-.009l-5.575-2.583a.6.6 0 0 1-.348-.543L1.9 4.529a.6.6 0 0 1 .353-.547l5.585-2.529ZM3.1 5.468l.008 5.565 4.376 2.028V7.5L3.101 5.468Zm5.584 2.039v5.588L12.9 11.31V5.636L8.685 7.507Zm3.41-2.826L8.072 2.665l-4.131 1.87 4.15 1.923 4.004-1.777Z';
const draw24px = 'M3.59,6.58h0l0,0ZM20.72,7a.41.41,0,0,0-.07-.17.61.61,0,0,0-.07-.1.43.43,0,0,0-.12-.11l-.05,0,0,0h0s0,0,0,0L12.4,2.79l-.08,0a.74.74,0,0,0-.72,0L3.68,6.53s0,0,0,0h0l0,0,0,0a.49.49,0,0,0-.18.2A.71.71,0,0,0,3.28,7a.69.69,0,0,0,0,.2V17.1a.75.75,0,0,0,.45.68l7.89,3.49.11.05.14.05.16,0,.17,0,.12,0h0l.1-.05,7.9-3.49a.75.75,0,0,0,.44-.68V7.21A.69.69,0,0,0,20.72,7ZM11.25,19.48l-6.5-2.87V8.36l6.5,2.88ZM12,9.93,5.81,7.18,12,4.25l6.19,2.94Zm7.24,6.68-6.5,2.87V11.24l6.5-2.88Zm1.14-10,0,0h0Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const BoxIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'box'));
BoxIcon.displayName = 'BoxIcon';
BoxIcon.propTypes = Icon.propTypes;
BoxIcon.renderIcon = props => /*#__PURE__*/React.createElement(BoxIcon, props);
export default BoxIcon;
//# sourceMappingURL=BoxIcon.js.map